import { environment } from "../../config";
import {
  DeletedObjetivos,
  EditObjetivoFields,
  iDataObjetivo,
  PostObjetivoFields,
} from "../../interfaces/SuperAdmin/Pages/iDataObjetivos";

import { fetchData } from "./httpClient";

const { REACT_APP_API_OAS } = environment;
const baseApiBroker = REACT_APP_API_OAS;

export const getObjetivosByOrgId = (id_organizacion: string) =>
  fetchData<iDataObjetivo[]>({
    method: "GET",
    url: `${baseApiBroker}/objetivo/organizacion/${id_organizacion}`,
  });

export const getObjetivoById = (id_objetivo: string) =>
  fetchData<iDataObjetivo>({
    method: "GET",
    url: `${baseApiBroker}/objetivo/${id_objetivo}`,
  });

export const deleteObjetivos = (data: { ids: string[] }) =>
  fetchData<DeletedObjetivos>({
    method: "DELETE",
    url: `${baseApiBroker}/objetivo`,
    data,
  });

export const putObjetivoById = (
  data: EditObjetivoFields,
  id_objetivo: string
) =>
  fetchData<iDataObjetivo>({
    method: "PUT",
    url: `${baseApiBroker}/objetivo/${id_objetivo}`,
    data,
  });

export const postObjetivo = (
  data: PostObjetivoFields,
  id_organizacion: string
) =>
  fetchData<iDataObjetivo>({
    method: "POST",
    url: `${baseApiBroker}/objetivo/organizacion/${id_organizacion}`,
    data,
  });
